import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'

export const CopyCodeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Code = styled.strong`
  min-width: 144px;
`

export const CopyCodeIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CopyCodeButton = styled(CommonLinkButton)`
  padding: 0;
`
